import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOAD_STATES } from '../../../reducers/common';
import { chooseColumnReference, listColumnOptions, listDictionaryOptions, syncActions } from '../../../actions/dictionary-values';
import history from '../../../history';
import { Box, Flex, Grid } from '@chakra-ui/react';
import { Form } from '../form';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { showFeedback } from '../../../actions/ui';
import LoaderOverlay from '../../../components/loader-overlay/loader-overlay';
import { styles } from '../dictionary-styles';
const CrossMapEdit = (props)=>{
    const dispatch = useDispatch();
    const { loadState, activeColumn, activeColumnMetadataObj } = useSelector((state)=>{
        return state.dictionaryValues.columnMetadataEditor;
    });
    const tenantId = useSelector((state)=>{
        return state.dictionaryRequest.dictionaryMetadata.tenantId;
    });
    const { columnMetadataForm, loadState: tenantLoad } = useSelector((state)=>{
        return state.dictionaryRequest;
    });
    const tenantOptions = useSelector((state)=>{
        // Getting tenant list from metadata form
        return state.dictionaryRequest?.columnMetadataForm?.fields?.[1]?.options ?? [];
    });
    const isTenantListLoading = tenantLoad === LOAD_STATES.started;
    useEffect(()=>{
        if (activeColumn.keyColumnIndicator) {
            dispatch(showFeedback({
                message: `Crossmapping the key column ${activeColumn.name} is not advised. Key columns should be unique to a dictionary.`,
                meta: {
                    level: 'WARNING'
                },
                dismissable: true,
                className: 'feedback-error',
                id: Date.now()
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handlePropChange = (prop, value)=>{
        if (prop === 'referenceTenant') {
            let organizationName = '';
            tenantOptions?.forEach((tenant)=>{
                if (tenant.key === value) {
                    organizationName = tenant.tenantName;
                }
            });
            const payload = {
                tenantId: value,
                orgName: organizationName
            };
            dispatch(listDictionaryOptions(payload));
        }
        if (prop === 'referenceDictionary') {
            const payload = {
                tenantId: tenantId,
                dictionaryName: value
            };
            dispatch(listColumnOptions(payload));
        }
        if (prop === 'referenceColumn') {
            dispatch(chooseColumnReference(value));
        }
    };
    const handleSaveCrossmap = (submitEvent)=>{
        const payload = {
            mappingInfo: submitEvent,
            columnInfo: activeColumn
        };
        dispatch(syncActions.saveColumnMapping(payload));
        props.history.goBack();
    };
    const handleAction = (event)=>{
        const { detail } = event;
        if (detail.eventType === 'cancel') {
            const pathParts = window.location.pathname.split('/');
            pathParts.pop();
            pathParts.pop();
            history.push(`${pathParts.join('/')}`);
        }
    };
    const subformEnabler = ()=>{
        return loadState !== LOAD_STATES.started;
    };
    const classes = styles();
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                sx: isTenantListLoading ? classes.breadCrumbGrid : {},
                children: /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
                })
            }),
            isTenantListLoading ? /*#__PURE__*/ _jsx(Grid, {
                sx: classes.loaderWrapper,
                children: /*#__PURE__*/ _jsx(LoaderOverlay, {})
            }) : /*#__PURE__*/ _jsx(Box, {
                overflowY: "auto",
                children: /*#__PURE__*/ _jsx(Form, {
                    formDefinition: columnMetadataForm,
                    dataItem: activeColumnMetadataObj,
                    onPropChange: handlePropChange,
                    onSave: handleSaveCrossmap,
                    enable: subformEnabler,
                    onAction: handleAction,
                    title: `${activeColumn?.name} Crossmaps`,
                    errors: {
                        status: '',
                        message: null,
                        errors: [],
                        fieldErrors: {}
                    },
                    inline: false
                })
            })
        ]
    });
};
export { CrossMapEdit };
